// Peoply landing'in dar ekran tasarımları: Mobil V9 (390px artboard) ve Tablet V9 (834px artboard). Masaüstü (Roadmap v9)
// tasarımı 1280px sabit yerleşimlidir; bu genişliklerin altında onun yerine ilgili kompakt markup render edilir.
// Artboard ekran genişliğine ölçeklenir (zoom); geniş ekranlarda aşırı büyümesin diye üst sınır vardır.
export const LANDING_COMPACT_LAYOUTS = {
  mobile: { mediaQuery: '(max-width: 639px)', artboardWidth: 390, maxZoom: 1.25 },
  tablet: { mediaQuery: '(min-width: 640px) and (max-width: 1023px)', artboardWidth: 834, maxZoom: 1.2 },
} as const;

export const LANDING_COMPACT_LANG_MOUNT_ID = 'peoply-landing-compact-lang';
export const LANDING_COMPACT_MENU_MOUNT_ID = 'peoply-landing-compact-menu';
export const LANDING_COMPACT_ACTION_ATTR = 'data-landing-action';
// Markup'taki data-landing-action değerleri: demo -> demo talep formu, signup -> kayıt sayfası, login -> giriş sayfası.
export const LANDING_COMPACT_ACTIONS = { demo: 'demo', signup: 'signup', login: 'login' } as const;
// Hamburger menüsündeki öğeler (landingPage.roadmap.<anahtar>); eylemleri masaüstü menüsüyle aynıdır.
export const LANDING_COMPACT_MENU_ITEMS = ['navJobs', 'navPricing', 'navSignup', 'navLogin'] as const;

// Kompakt markup'ta olup masaüstü yol haritası kataloğunda (landingPage.roadmap) bulunmayan metinler: kaynak (Türkçe)
// metin -> tam i18n anahtarı.
export const LANDING_COMPACT_EXTRA_TEXT_KEYS: Record<string, string> = {
  'Süreci bize bırak,': 'landingPage.cta.titleLine1',
  'kararı sen ver.': 'landingPage.cta.titleLine2',
  'Profilini güçlendir, sana uyan fırsatları gör; firman için doğru yeteneği bul ve işe alımını hızlandır.':
    'landingPage.cta.description',
  'İş aramaya başla': 'landingPage.cta.seekJobs',
  'Aday bulmaya başla': 'landingPage.cta.findCandidates',
  '← KAYDIR →': 'landingPage.mobile.scrollHint',
};
